import store from '@/store';

export default class VoiceRedialEvent {
  constructor(body) {
    window.console.log('[VoiceRedialEvent]', JSON.parse(JSON.stringify(body)));
    store.dispatch('jobs/enableJob', body.protocol);
  }
}
